import * as constActions from './ArpConstsActions';
import initialState from './ArpInitialState';

export default function ArpReducer(state = initialState, action) {
  switch (action.type) {
    /* Get Arp Entries Columns */
    case constActions.GET_ARP_ENTRIES_COLUMNS_REQUEST: {
      return state;
    }
    case constActions.GET_ARP_ENTRIES_COLUMNS_SUCCESS: {
      return Object.assign({}, state, {
        columns: action.results
      });
    }
    case constActions.GET_ARP_ENTRIES_COLUMNS_FAILURE: {
      return state;
    }

    /* Get Arp Entries */
    case constActions.GET_ARP_ENTRIES_REQUEST: {
      return state;
    }
    case constActions.GET_ARP_ENTRIES_FAILURE: {
      return state;
    }
    case constActions.GET_INITIAL_ARP_ENTRIES_SUCCESS: {
      return Object.assign({}, state, {
        results: [...action.results]
      });
    }
    case constActions.GET_ARP_ENTRIES_SUCCESS: {
      return Object.assign({}, state, {
        results: [...state.results, ...action.results]
      });
      // return Object.assign({}, state, {
      //     results: [...state.results, ...action.results]
      // });
    }

    /* Save search parameters */
    case constActions.SAVE_ARP_ENTRIES_SEARCH_PARAMETERS: {
      return Object.assign({}, state, {
        parameters: action.parameters
      });
    }

    /* Select Arp Entries */
    case constActions.SELECT_ARP_ENTRIES_SUCCESS: {
      return Object.assign({}, state, {
        selectedArpEntries: JSON.parse(JSON.stringify(action.selectedArpEntries))
      });
    }
    case constActions.SELECT_ALL_ARP_ENTRIES_SUCCESS: {
      return Object.assign({}, state, {
        isSelectAllChecked: action.isSelectAllArpEntriesChecked
      });
    }

    /* Add Edit Comment to Arp Entries */
    case constActions.ADD_OR_EDIT_ARP_ENTRIES_COMMENTS_REQUEST: {
      return state;
    }
    case constActions.ADD_OR_EDIT_ARP_ENTRIES_COMMENTS_SUCCESS: {
      return Object.assign({}, state, {
        results: [...action.updatedResults]
      });
    }

    default:
      return state;
  }
}
